<template>
  <v-touch v-on:panleft="onPan"
           v-on:panright="onPan"
           v-on:panstart="setPanStart"
           v-on:panend="onPanEnd"
           v-bind:pan-options="{ direction: 'horizontal', threshold: 4 }"
           class="day-cal__overlay">
    <div class="days-container" :style="{transform: 'translate3d(' + translateX + '%, 0, 0)'}">
      <template v-for="cal in calendars">
        <div class="day" :style="{webkitTransform: 'translate3d(' + cal.style + '%, 0,0)'}">
          <transition name="fadeDown">
            <mobile-datepicker
              v-show="isActive"
              :date="cal.date"
              :theCalendarDate="theCalendarDate"
              @changed="setCalDate">
            </mobile-datepicker>
          </transition>
        </div>
      </template>
    </div>
  </v-touch>
</template>

<script>
import mobileDatepicker from '../../../datepicker/DatepickerMobile.vue'
import moment from 'moment'

export default {
  props: {
    date: {
      default: () => moment()
    },
    theCalendarDate: {
      default: () => moment()
    },
    active: {
      type: Boolean,
      default: false
    },
    dateChange: {}
  },
  components: {mobileDatepicker},
  data () {
    return {
      calendars: [],
      translateX: 0,
      panStart: 0,
      panCurrent: 0,
      isScrolling: false,
      isActive: false
    }
  },
  watch: {
    active (val) {
      if (val) {
        setTimeout(_ => {
          this.isActive = true
        })
      } else {
        this.isActive = false
      }
    }
  },
  methods: {
    addThreeCalendars () {
      this.addCal(this.date)
      let prev = moment(this.date).subtract(1, 'months')
      let next = moment(this.date).add(1, 'months')
      this.addCal(prev)
      this.addCal(next)
    },
    addCal (date) {
      const calDate = moment(date).locale('en').format('YYYY-MM-DD')
      const calDateStartOfMonth = moment(calDate).startOf('month')
      const dateStartOfMonth = moment(this.date).startOf('month')
      const diff = moment(calDateStartOfMonth).diff(dateStartOfMonth, 'months', false)
      let disX = 100 * diff
      this.calendars.push(
        {date: calDate, style: disX}
      )
    },
    updateCal (date) {
      let calDate = moment(this.date).locale('en').format('YYYY-MM-DD')
      for (let i = 0; i < 3; i++) {
        const calDateStartOfMonth = moment(calDate).startOf('month')
        const dateStartOfMonth = moment(this.calendars[i].date).startOf('month')
        let dateDiff = moment(calDateStartOfMonth).diff(dateStartOfMonth, 'months')
        if (dateDiff === -2) {
          let prevDate = moment(date).subtract(1, 'months').locale('en').format('YYYY-MM-DD')
          let x = this.translateX + 100
          this.calendars[i].date = prevDate
          this.calendars[i].style = -x
        }
        if (dateDiff === 2) {
          let nextDate = moment(date).add(1, 'months').locale('en').format('YYYY-MM-DD')
          let x = this.translateX - 100
          this.calendars[i].date = nextDate
          this.calendars[i].style = -x
        }
      }
    },
    setPanStart (e) {
      this.panStart = e.srcEvent.pageX || e.pointers[0].pageX
    },
    onPan (e) {
      e.preventDefault()
      this.panCurrent = e.srcEvent.pageX || e.pointers[0].pageX
      const element = document.querySelector('.days-container')
      let distanceX = this.panCurrent - this.panStart
      let percentage = distanceX / (element.getBoundingClientRect().width) * 100
      let range = this.translateX + percentage
      element.style.transitionDuration = '0ms'
      element.style.webkitTransform = 'translate3d(' + range + '%, 0,0)'
    },
    onPanEnd (e) {
      const element = document.querySelector('.days-container')
      element.style.transitionDuration = '0ms'
      element.style.webkitTransform = 'translate3d(' + 0 + '%, 0,0)'
      let distanceX = this.panCurrent - this.panStart
      if (Math.abs(distanceX) < 55) {
        this.scrollToDate(this.translateX, 5)
      } else {
        if (distanceX > 55) {
          this.translateX = this.translateX + 100
          this.scrollToDate(this.translateX, 35)
          let date = moment(this.date).subtract(1, 'months').locale('en').format('YYYY-MM-DD')
          this.$emit('changed', date)
          setTimeout(() => {
            this.updateCal(this.date)
          }, 200)
        } else {
          this.translateX = this.translateX - 100
          this.scrollToDate(this.translateX, 35)
          let date = moment(this.date).add(1, 'months').locale('en').format('YYYY-MM-DD')
          this.$emit('changed', date)
          setTimeout(() => {
            this.updateCal(this.date)
          }, 200)
        }
      }
      this.panStart = null
    },
    scrollToDate (scroolX, speed) {
      const element = document.querySelector('.days-container')
      element.style.webkitTransform = 'translate3d(' + scroolX + '%, 0,0)'
      element.style.transition = '0.' + speed + 's'
    },
    setCalDate (date) {
      this.translateX = 0
      this.scrollToDate(0, 0)
      this.$emit('setDate', date)
    }
  },
  mounted () {
    this.addThreeCalendars()
  }
}
</script>

<style scoped>
.days-container {
  transform: translate3d(0%, 0%, 0px);
  position: relative;
  display: flex;
  z-index: 1000;
  will-change: transform;
}

.days-container > .day {
  flex: 1;
  width: 100%;
  position: absolute;
  left: 0;
  will-change: transform;
  min-height: 240px;
}

</style>



// WEBPACK FOOTER //
// PanContainer.vue?65312b80